import React, { useState } from 'react';
import ModalRecords from './ModalRecords/ModalRecords';
import DashboardWheel from './DashboardWheel/DashboardWheel';
import ArrowSvg from '../../../Assets/icons/ArrowDarkBlue.svg';
import './MyOolaScore.css';
import AliceCarousel from 'react-alice-carousel';

const MyOolaScore = (props) => {
    const [showModalRecords, setShowModalRecords] = useState(false);
    const scores = props.AllState.OolaScore ?? [];
    const scoredItems = scores.filter((x) => x.score > 0);

    const responsive = {
        0: { items: 1 },
        568: { items: 3 },
        1024: { items: 3 },
    };
    const renderNextButton = () => (
        <img
            src={ArrowSvg}
            style={{ transform: 'rotate(180deg)' }}
            alt=""
            className={`ArrowMyOolaScoreCarousel Right ${
                scoredItems.length < 4 ? 'hideArrow' : ''
            }`}
        />
    );

    const renderPrevButton = () => (
        <img
            src={ArrowSvg}
            alt=""
            className={`ArrowMyOolaScoreCarousel Left ${
                scoredItems.length < 4 ? 'hideArrow' : ''
            }`}
        />
    );

    const newItems = scoredItems.map((item, i) => (
        <div key={`DashboardWheel__item${i}`} className="myOolaScore__ItemContainer">
            <div className="miniWheel__container">
                <DashboardWheel AllState={item} currBadget={props.currBadget} />
            </div>
            <h3 className="NumberMyOolaScore">{item.score}</h3>
            <h6 className="heading-6">
                <p>{String(item.completionDate).split(' ')[0]}</p>
                {String(item.completionDate).split(' ')[1]}{' '}
                {String(item.completionDate).split(' ')[2]}
            </h6>
        </div>
    ));

    return (
        <article className="myOolaScore">
            <div className="TitleDashboardContent">
                <p className="heading-5 BlueDarkText">MY OOLA SCORE</p>
            </div>
            <div className="myOolaScore__container Carrousel">
                {scoredItems.length > 0 ? (
                    <AliceCarousel
                        mouseTracking
                        items={newItems}
                        responsive={responsive}
                        controlsStrategy="alternate"
                        renderPrevButton={renderPrevButton}
                        renderNextButton={renderNextButton}
                    />
                ) : (
                    <p className="myOolaScore__empty BlueDarkText">
                        Complete your Life Blueprint to see your Oola Score
                        history.
                    </p>
                )}
            </div>
            {scores.length > 0 && showModalRecords === true && (
                <ModalRecords
                    OolaScore={scores}
                    show={showModalRecords}
                    setShow={setShowModalRecords}
                />
            )}
        </article>
    );
};
export default MyOolaScore;
